// extracted by mini-css-extract-plugin
module.exports = {"bleeder":"bleeder_bleeder__1GXfG","full":"bleeder_full__Bja0Q"};